import { css, styled } from "../../../../../../styles";

export const ListBlowItem = styled("div", {
  width: "220px",
  padding: "4px 16px",
  marginBottom: "2px",

  borderRadius: "8px",

  fontFamily: "$openSans",
  fontSize: "$text-md",

  color: "$gray-80",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  cursor: "pointer",

  p: {
    paddingRight: "6px",
  },

  "@sm": {
    paddingLeft: "1px",
    width: "100%",
    justifyContent: "flex-start",
    background: "$white !important",

    svg: {
      marginRight: "30px",
      width: "16px !important",
    },
  },

  variants: {
    isHovered: {
      true: {
        background: "$gray-30",
      },
    },
    isOpaque: {
      true: {
        opacity: 0.28,
      },
    },
  },
});

export const SpirometryListTitle = styled("div", {
  lineHeight: "16px",
  textAlign: "end",

  marginRight: "80px",
  marginBottom: "8px",

  fontWeight: 600,
  fontSize: "$text-md",

  color: "$gray-90",

  display: "flex",
  justifyContent: "flex-end",

  p: {
    paddingLeft: "11px",
  },

  "@sm": {
    width: "100%",
    justifyContent: "flex-start",
    padding: "0 16px 0 1px",
  },
});

export const ListBlowHoverCardContent = styled("div", {
  maxWidth: "216px",
  zIndex: "10",
  width: "196px",

  position: "absolute",

  marginTop: "14px",

  backgroundColor: "$charcoal",
  overflowWrap: "break-word",

  color: "$white",
  fontFamily: "$openSans",

  fontWeight: 500,
  fontSize: "$text-md",
  lineHeight: "16px",

  borderRadius: "4px",

  padding: "18px 32px",

  p: {
    marginBottom: "6px",

    "&:last-child": {
      marginBottom: 0,
    },
  },
});

export const BlowColorDot = styled("div", {
  width: "6px",
  height: "6px",

  borderRadius: "50%",
});

export const archiveButtonCss = css({
  color: "var(--colors-gray-60)",

  "&:hover": {
    color: "var(--colors-gray-70)",
  },
});

// CSS

export const skeletonCss = css({
  "&.ant-skeleton": {
    ".ant-skeleton-content": {
      ".ant-skeleton-paragraph": {
        li: {
          width: "85%",
          height: "25px !important",
          borderRadius: "8px",
        },
      },
    },
  },
});
